export const AUTH_STATE_STATUSES = {
  NOT_CONNECTED: 'not_connected',
  INACTIVE: 'inactive',
  CONNECTED: 'connected',
  PENDING_VALIDATION: 'pending_validation',
  FAILURE_VALIDATION: 'failure_validation',
  UPGRADE_TO_OAUTH2: 'upgrade_to_oauth2'
};

const styles = {
  not_connected: {
    backgroundColor: 'catskillGray',
    border: 'catskillWhite'
  },
  connected: {
    backgroundColor: 'fetaLight',
    border: 'feta'
  },
  inactive: {
    backgroundColor: 'bridalHeath',
    border: 'serenade'
  }
};

export const mapAuthStatusToStyleProps = {
  [AUTH_STATE_STATUSES.NOT_CONNECTED]: styles.not_connected,
  [AUTH_STATE_STATUSES.CONNECTED]: styles.connected,
  [AUTH_STATE_STATUSES.INACTIVE]: styles.inactive,
  [AUTH_STATE_STATUSES.PENDING_VALIDATION]: styles.inactive,
  [AUTH_STATE_STATUSES.FAILURE_VALIDATION]: styles.not_connected,
  [AUTH_STATE_STATUSES.UPGRADE_TO_OAUTH2]: styles.connected
};
